var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPromptRecommendedFeaturesAutomation = function SvgIconPromptRecommendedFeaturesAutomation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#4B4F58",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "M7.625 3.333H3.5c-.828 0-1.5.733-1.5 1.638V6m3 8v-2.667m0-8V6m6 8v-2.667m0-3v.334m3 2.666V8.667h-3m3 2.666v1.03c0 .904-.672 1.637-1.5 1.637h-9c-.828 0-1.5-.733-1.5-1.637v-1.03m12 0h-3m0 0V8.667m-9 2.666V8.667m0 2.666h3m0 0V8.667m0 0V6m0 2.667H2m0 0V6m0 0h3m6.858.617.149-.34c.262-.6.742-1.082 1.346-1.35l.46-.203A.32.32 0 0 0 14 4.435a.32.32 0 0 0-.187-.289l-.435-.191a2.63 2.63 0 0 1-1.364-1.396l-.154-.366A.305.305 0 0 0 11.575 2a.31.31 0 0 0-.286.193l-.153.366a2.64 2.64 0 0 1-1.364 1.396l-.436.192a.32.32 0 0 0-.186.288.32.32 0 0 0 .186.289l.461.203c.603.267 1.083.75 1.345 1.35l.15.34c.109.248.456.248.566 0"
  })));
};
export default SvgIconPromptRecommendedFeaturesAutomation;